import {register} from "../api/RegisterApi";

const registerAction = (payload) => async dispatch => {
  return await register(payload);
};

export { registerAction };